/**
 * deferredHints.js
 *
 * Simple utility for "show once on next open" hints.
 * A hint is written to localStorage before the taskpane closes,
 * and read + cleared the next time the taskpane loads.
 *
 * Usage:
 *   // Schedule a hint (e.g. inside a modal before it closes):
 *   scheduleHint(HINTS.AUTO_PREFILL_TIP);
 *
 *   // Consume pending hints (e.g. on component mount):
 *   const hints = consumeHints();
 *   // hints is a Set of hint keys that were pending
 */

const LS_PREFIX = "avamboo_hint_";

/** All known hint keys — add new ones here. */
export const HINTS = {
  /** Shown when PM found a stored password but auto-prefill setting is off. */
  AUTO_PREFILL_TIP: "auto_prefill_tip",
};

/**
 * Schedule a hint to be shown on the next taskpane open.
 * Safe to call multiple times — idempotent.
 * @param {string} hintKey - One of the HINTS constants.
 */
export function scheduleHint(hintKey) {
  try {
    localStorage.setItem(LS_PREFIX + hintKey, "1");
  } catch (_) {}
}

/**
 * Read all pending hints and clear them from localStorage.
 * Call once on mount — returns a Set of hint keys.
 * @returns {Set<string>}
 */
export function consumeHints() {
  const pending = new Set();
  try {
    for (const key of Object.values(HINTS)) {
      if (localStorage.getItem(LS_PREFIX + key) === "1") {
        pending.add(key);
        localStorage.removeItem(LS_PREFIX + key);
      }
    }
  } catch (_) {}
  return pending;
}
